import React, {memo, useEffect, useMemo, useState} from 'react';
import {shallowEqual, useSelector} from "react-redux";
import {Pagination, Table} from "antd";
import {t} from "@lingui/macro";
import {css} from "styled-components";
import {SmileOutlined} from "@ant-design/icons";
import FormatNumber from "../../FormatNumber";

export const TransferredToPopoverStyled = css`
  .transferred-to-popover {
    .ant-popover-inner-content {
      padding: 0;
    }
    
    .ant-table.ant-table-small .ant-table-thead > tr > th:first-child,
    .ant-table.ant-table-small .ant-table-tbody > tr > td:first-child {
      padding-left: 12px
    }

    .ant-table.ant-table-small .ant-table-thead > tr > th:last-child,
    .ant-table.ant-table-small .ant-table-tbody > tr > td:last-child {
      padding-right: 12px
    }
    
    .ant-table.ant-table-small {
      .ant-table-content {
        height: 235px;
      }

      .ant-table-placeholder {
        display: none;
      }
    }
    
    .wrapper {
      display: flex;
      flex-flow: column nowrap;
      width: 280px;
      height: 280px;
      
      .table-container {
        flex: 1;
      }

      .pagination-container {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        padding: 8px;
      }

      .error-container {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        color: #ff7875;
        background-color: #ffffff90;
        
        .error-icon {
          font-size: 30px;
        }

        .error-text {
          padding-bottom: 55px;
        }
      }
    }
  }
`;

function TransferredToInfoPopover() {
    const [current, setCurrent] = useState(1);
    const pageSize = 5;

    const transferToTransactions = useSelector(
        state => state.Transaction.transferToTransactions,
        shallowEqual,
    );

    useEffect(() => {
        if (transferToTransactions === 'request')
            setCurrent(1);
    }, [transferToTransactions]);

    const readTransferToInfoState = useSelector(state => state.Transaction.readTransferToInfoState);

    const dataSource = useMemo(() => {
        const firstIdx = parseInt((current - 1) * pageSize, 10);
        const lastIdx = firstIdx + pageSize;
        return transferToTransactions.slice(firstIdx, Math.min(lastIdx, transferToTransactions.length));
    }, [current, transferToTransactions]);

    return (
        <div className="wrapper" onClick={e => e.stopPropagation()}>
            <div className="table-container">
                <Table
                    size="small"
                    columns={[
                        {
                            key: 'transaction',
                            dataIndex: 'transaction',
                            title: t`Transferred To`,
                            render: (text, record) => (
                                <a
                                    href={record.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    { record.number }
                                </a>
                            ),
                        },
                        {
                            key: 'quantity',
                            dataIndex: 'quantity',
                            align: 'right',
                            title: t`Quantity`,
                            render: (text, record) => (
                                <span style={{lineHeight: 1}}>
                                    <span style={{color: 'black', marginBottom: 0}}>
                                        <FormatNumber amount={record.quantity} dp={2} dp2={4} />
                                    </span>
                                    {
                                        record.product_unit_label ?
                                            <span style={{
                                                color: 'grey',
                                                marginBottom: 0,
                                                marginLeft: 2,
                                            }}
                                            >
                                                <sub style={{bottom: 0}}>
                                                    {record.product_unit_label || ''}
                                                </sub>
                                            </span> : null
                                    }
                                </span>
                            ),
                        },
                    ]}
                    loading={{
                        spinning: readTransferToInfoState === 'request',
                        tip: "Loading...",
                    }}
                    dataSource={dataSource}
                    pagination={false}
                />
            </div>
            <div className="pagination-container">
                <Pagination
                    current={current}
                    onChange={setCurrent}
                    total={transferToTransactions.length}
                    pageSize={pageSize}
                    size="small"
                    disabled={readTransferToInfoState === 'request' || readTransferToInfoState === 'error'}
                />
            </div>
            {
                readTransferToInfoState === 'error' ?
                    <div className="error-container">
                        <div className="error-icon">
                            <SmileOutlined />
                        </div>
                        <div className="error-text">
                            {t`Please try again later...`}
                        </div>
                    </div> :
                    null
            }
        </div>
    );
}

export default memo(TransferredToInfoPopover);
